module.exports = __webpack_public_path__ + "img/code-qy.ce55bbb6.jpg";